import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Copy, Gift, Users } from "lucide-react";

export default function ReferralCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/referral").then(r => setData(r.data)).catch(()=>{}); }, []);
  if (!data) return null;
  const link = `${window.location.origin}/login?ref=${data.code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Lien copié !"); }
    catch { toast.error("Impossible de copier"); }
  };
  return (
    <section className="glass-strong rounded-2xl p-6">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><Gift size={16} className="text-[#F59E0B]"/> Parrainage</h2>
      <p className="mt-2 text-sm text-slate-400">Invitez un ami : à chaque inscription via votre lien, vous gagnez <b>1 déblocage gratuit (valeur 2€)</b>.</p>
      <div className="mt-3 flex gap-2">
        <input data-testid="referral-link" readOnly value={link} className="flex-1 px-3 py-2 rounded-lg bg-slate-900/60 border border-slate-700 text-xs outline-none"/>
        <button data-testid="referral-copy" onClick={copy} className="btn-coral px-3 py-2 rounded-lg text-sm flex items-center gap-1"><Copy size={14}/> Copier</button>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
        <div className="glass rounded-lg p-3 flex items-center gap-2"><Users size={12} className="text-[#F59E0B]"/> {data.invites} filleul(s)</div>
        <div className="glass rounded-lg p-3 flex items-center gap-2"><Gift size={12} className="text-[#F59E0B]"/> {data.free_unlocks} crédit(s) restant(s)</div>
      </div>
    </section>
  );
}
